var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4109_19802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 39.9963C80 62.0841 62.0915 79.9926 40.0037 79.9926C17.9085 80 0 62.0841 0 39.9963C0 17.9085 17.9085 0 39.9963 0C62.0915 0 80 17.9085 80 39.9963Z",
    fill: "#FF451B",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 39.9966C75 59.3264 59.3318 75 40 75C20.6682 75 5 59.3333 5 39.9966C5 20.6667 20.6682 5 40 5C59.3249 5 75 20.6667 75 39.9966Z",
    fill: "#E5401C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8226 25.0756C58.196 26.449 58.196 28.7072 56.8226 30.0806L30.0806 56.8226C28.701 58.2022 26.449 58.2022 25.0756 56.8226L24.0301 55.7771C22.6566 54.3975 22.6566 52.1455 24.0301 50.7659L50.7659 24.0301C52.1455 22.6566 54.3975 22.6566 55.7771 24.0301L56.8226 25.0756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8067 56.8255C54.4333 58.199 52.1752 58.199 50.8017 56.8255L24.0597 30.0835C22.6801 28.7039 22.6801 26.452 24.0597 25.0785C25.4393 23.7051 25.1052 24.033 25.1052 24.033C26.4849 22.6596 28.7368 22.6596 30.1164 24.033L56.8523 50.7688C58.2257 52.1485 58.2257 54.4004 56.8523 55.78L55.8067 56.8255Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4109_19802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/Failed.b6c6d535546f4c2ba4d5da62424afa35.svg";
export { ForwardRef as ReactComponent };